module.exports = __webpack_public_path__ + "img/serve_icon.95b9b801.png";